<template>
  <div class="course-recommend f-right">
    <div class="course-recommend-header">推荐课程</div>
    <Empty
      class="empty"
      v-if="recommendCourses.length == 0"
      title="暂无推荐课程！"
    />
    <template v-else>
      <RichCourseItem
        class="course-recommend-item"
        v-for="course in recommendCourses"
        :key="course.id"
        :course="course"
        :showTime="false"
        :hasHover="false"
        :width="298"
        :height="198"
        :showPeriods="false"
        from="recommend"
      ></RichCourseItem>
    </template>
  </div>
</template>
<script>
import RichCourseItem from "./CourseItem.vue";

export default {
  name: "CourseShowRecommend",
  components: { RichCourseItem },
  props: {
    recommendCourses: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
.item{
  margin-right: 0 !important;
}

.course-recommend {
  width: 298px;

  .course-recommend-header {
    height: 50px;
    background: rgba(255, 255, 255, 1);
    border-radius: 3px;
    font-size: 18px;
    font-weight: 500;
    line-height: 50px;
    padding-left: 20px;
    margin-bottom: 20px;
  }

  .empty {
    border-radius: 15px;
  }

  .course-recommend-item {
    height: auto;
    float: none;
    margin-right: 0;
    width: auto;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    box-sizing: border-box;
    margin-bottom: 20px;
    border: none;

    &:last-child {
      margin-bottom: 0;
    }

    /deep/ {
      .cover {
        margin-bottom: 18px;
      }

      .body {
        padding: 0 16px 0 16px;
      }

      .title-wrap {
        margin-bottom: 5px;
        max-height: 44px;
      }

      .title {
        font-size: 16px;
        line-height: 22px;
      }

      .course-type {
        top: 157px;
      }

      .course-footer {
        position: static;
        width: auto;
        padding: 0;
      }

      .teacher,
      .course-footer {
        display: none;
      }

      .right {
        flex-grow: 1;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: flex-end;
      }
    }
  }
}
</style>
